import React from 'react'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import { SvgIconProps } from '@mui/material/SvgIcon'

const ReportIcon = (props: SvgIconProps) => {
  return <AssessmentOutlinedIcon {...props} htmlColor="#ADACA8" />
}

export default ReportIcon
